module.exports = __webpack_public_path__ + "static/img/success.5ac41cb.png";